import EntriesList from './EntriesList';

export default EntriesList;
